import type { PropsWithChildren } from "react";
import { Box, createStyles, makeStyles } from "@material-ui/core";

import theme from "theme";

const copyFontSize = "1.125rem";
const useStyles = makeStyles(() =>
  createStyles({
    content: {
      color: theme.palette.text.primary,
      fontSize: copyFontSize,
      lineHeight: "1.5rem",
      textAlign: "left",
      "& h1": {
        fontSize: "1.625rem",
        fontWeight: theme.typography.fontWeightBold,
      },
      "& a": {
        color: theme.custom.palette.blue.main,
        fontSize: copyFontSize,
        "&:hover": {
          textDecoration: "underline",
        },
      },
      "& p": {
        color: theme.palette.text.primary,
        fontSize: copyFontSize,
        lineHeight: "1.5rem",
      },
      "& ul": {
        color: theme.palette.text.primary,
        fontSize: copyFontSize,
        lineHeight: "1.5rem",
      },
      "& li": {
        color: theme.palette.text.primary,
        fontSize: copyFontSize,
      },
      [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down("xs")]: {
        textAlign: "left",
      },
    },
  }),
);

const ParagraphContent = ({ children }: PropsWithChildren) => {
  const classes = useStyles();
  return <Box className={classes.content}>{children}</Box>;
};

export default ParagraphContent;
